type ValueOf<T> = T[keyof T]

/** Kind */
export const Kind = {
  Solid: 'solid',
  Transparent: 'transparent',
  Outline: 'outline',
} as const

export type Kind = ValueOf<typeof Kind>

/** Sizes */
export const Sizes = {
  BB8: 'bb8',
  R2D2: 'r2d2',
  Yoda: 'yoda',
  Leia: 'leia',
  HanSolo: 'hanSolo',
  Luke: 'luke',
  Obi: 'obi',
  Ahsoka: 'ahsoka',
  Mandalorian: 'mandalorian',
  Vader: 'vader',
  Palpatine: 'palpatine',
} as const

export type SizesType = ValueOf<typeof Sizes>
export type ButtonSizes = typeof Sizes.R2D2 | typeof Sizes.Leia | typeof Sizes.HanSolo | typeof Sizes.Luke
export type TabSize = typeof Sizes.Leia | typeof Sizes.Luke

/** Hierarchy */
export const Hierarchy = {
  Action: 'action',
  Primary: 'primary',
  Secondary: 'secondary',
} as const

export type Hierarchy = ValueOf<typeof Hierarchy>

/** Segment Color */
export const SegmentColor = {
  Primary: 'primary',
  Secondary: 'secondary',
} as const

export type SegmentColor = ValueOf<typeof SegmentColor>

/** Button Variant */
export const ButtonVariant = {
  Accent: 'accent',
  Primary: 'primary',
  Secondary: 'secondary',
  Outline: 'outline',
  Ghost: 'ghost',
  Static: 'static',
  FunctionAccent: 'function_accent',
  Function: 'function',
} as const

export type ButtonVariant = ValueOf<typeof ButtonVariant>

/** CalendarCardType */
export const CalendarCardState = {
  Title: 'title',
  TitleToday: 'today',
  Blank: 'blank',
  Multi: 'multi',
  Book: 'book',
  Break: 'break',
  Process: 'process',
  Done: 'done',
  NotDone: 'not-done',
  Work: 'work',
  Confirmed: 'confirmed',
  NotConfirmed: 'not-confirmed',
  Tech: 'tech',
  Parallel: 'parallel',
}

export type CalendarCardStateType = ValueOf<typeof CalendarCardState>

/** CalendarCardKanbanVariant */
export const CalendarCardKanbanVariant = {
  Created: 'created',
  Confirmed: 'confirmed',
  Processed: 'processed',
  DidntCall: 'didnt-call',
  Past: 'past',
  Multi: 'multi',
  Tech: 'tech',
  Custom: 'custom',
} as const

export type CalendarCardKanbanVariantType = ValueOf<typeof CalendarCardKanbanVariant>

/** BackgroundType */
export const Background = {
  Gray: 'gray',
  Outline: 'outline',
  White: 'white',
} as const

export type BackgroundType = ValueOf<typeof Background>

/** Hierarchy */
export const DotState = {
  Active: 'active',
  Disabled: 'disabled',
} as const

export type DotState = ValueOf<typeof DotState>

export const Bg = {
  Grey: 'grey',
  None: 'none',
  White: 'white',
} as const

export type Bg = ValueOf<typeof Bg>

/** Badge */
export const BadgeVariant = {
  Accent: 'accent',
  Primary: 'primary',
  Info: 'info',
  Success: 'success',
  Error: 'error',
  Neutral: 'neutral',
  StaticWhite: 'static-white',
  StaticDark: 'static-dark',
} as const

export type BadgeVariant = ValueOf<typeof BadgeVariant>

export const BadgeDisplayType = {
  DotSmall: 'dot-small',
  Dot: 'dot',
  Text: 'text',
} as const

export type BadgeDisplayType = ValueOf<typeof BadgeDisplayType>

/** Chip */
export const ChipType = {
  Default: 'default',
  Accent: 'accent',
  Success: 'success',
  Disabled: 'disabled',
  Alert: 'alert',
  Neutral: 'neutral',
} as const

export type ChipType = ValueOf<typeof ChipType>

export const ChipVariant = {
  Primary: 'primary',
  Secondary: 'secondary',
  Selected: 'selected',
} as const

export type ChipVariant = ValueOf<typeof ChipVariant>

/** Tag */
export const TagType = {
  Base: 'base',
  BaseBorder: 'base-border',
  Accent: 'accent',
  Primary: 'primary',
  Success: 'success',
  Info: 'info',
  Error: 'error',
  Neutral: 'neutral',
} as const

export type TagType = ValueOf<typeof TagType>

/** Contrast Tag */
export const ContrastTagType = {
  Primary: 'primary',
  Info: 'info',
  Secondary: 'secondary',
  Success: 'success',
  Warning: 'warning',
  Error: 'error',
  Neutral: 'neutral',
  NeutralDark: 'neutral-dark',
} as const

export type ContrastTagType = ValueOf<typeof ContrastTagType>

export const MessageVariety = {
  Default: 'default',
  Error: 'error',
  Success: 'success',
  Mark: 'mark',
}

export type MessageVariety = ValueOf<typeof MessageVariety>

/** Advice */
export const AdviceType = {
  Accent: 'accent',
  Primary: 'primary',
  Info: 'info',
  Success: 'success',
  Error: 'error',
  Neutral: 'neutral',
} as const

export type AdviceType = ValueOf<typeof AdviceType>
